// Utility functions for stock validation

/**
 * Check if any items in the cart are out of stock
 * @param {Array} cartItems - Array of cart items
 * @returns {Object} - Object with hasOutOfStockItems boolean and outOfStockItems array
 */
export const checkCartStockAvailability = (cartItems) => {
  if (!cartItems || cartItems.length === 0) {
    return { hasOutOfStockItems: false, outOfStockItems: [] };
  }

  const outOfStockItems = cartItems.filter(item => {
    // Skip validation for unlimited items (quantity = -1)
    if (item.quantity === -1 || item.available_quantity === -1) {
      return false;
    }
    
    const availableQuantity = item.available_quantity || item.quantity || 0;
    const requestedQuantity = item.quantity || 1;
    
    return requestedQuantity > availableQuantity;
  });

  return {
    hasOutOfStockItems: outOfStockItems.length > 0,
    outOfStockItems: outOfStockItems
  };
};

/**
 * Check if a single item is out of stock
 * @param {Object} item - Item object
 * @param {number} requestedQuantity - Quantity being requested
 * @returns {boolean} - True if item is out of stock
 */
export const isItemOutOfStock = (item, requestedQuantity = 1) => {
  if (!item) return true;
  
  // Skip validation for unlimited items (quantity = -1)
  if (item.quantity === -1 || item.available_quantity === -1) {
    return false;
  }
  
  const availableQuantity = item.available_quantity || item.quantity || 0;
  return requestedQuantity > availableQuantity;
};

/**
 * Get stock status message for an item
 * @param {Object} item - Item object
 * @param {number} requestedQuantity - Quantity being requested
 * @returns {string} - Stock status message
 */
export const getStockStatusMessage = (item, requestedQuantity = 1) => {
  if (!item) return "Item not available";
  
  // Unlimited items
  if (item.quantity === -1 || item.available_quantity === -1) {
    return "Available";
  }
  
  const availableQuantity = item.available_quantity || item.quantity || 0;
  
  if (availableQuantity === 0) {
    return "Out of Stock";
  }
  
  if (requestedQuantity > availableQuantity) {
    return `Only ${availableQuantity} available`;
  }
  
  return "In Stock";
}; 